// extracted by mini-css-extract-plugin
export default {"greyLabel":"UpdatePositionModal__greyLabel___w0s2_","memberName":"UpdatePositionModal__memberName___nF7Wo","modal":"UpdatePositionModal__modal___eZfAq"};